import type { OnOpenGallery } from '@hotels-hotel-detail/data-access/types/hotel-images';
import type { MBDProps } from '@shared/types/frontend/meaningful-behaviour-data';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './ImageItem.module.scss';

import { NavigationItems } from '@hotels-hotel-detail/utils/gallery-navigation';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import PlayOverlay from '@shared/ui/common/PlayOverlay';
import ProgressivePictureButton from '@shared/ui/common/ProgressivePictureButton';
import { withI18n } from '@shared/ui/contexts/i18n';
import {
  buildTabletImageSrcset,
  buildDesktopImageSrcset,
  buildMobileImageSrcset,
} from '@shared/utils-universal/hotel-image';

type Props = {
  i18n: I18nService;
  imageIndex: number;
  mbdProps?: MBDProps;
  src: string;
  showVideoPlayOverlay: boolean;
  lazyLoad: boolean;
  openGallery: OnOpenGallery;
};

const ImageItem = ({
  i18n,
  imageIndex,
  lazyLoad,
  mbdProps,
  openGallery,
  showVideoPlayOverlay,
  src,
}: Props) => (
  <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
    {(isMobile: boolean) => {
      const openGalleryProps = {
        index: imageIndex,
        type: NavigationItems.hotel,
        showNavigation: !isMobile,
      };

      return (
        <ProgressivePictureButton
          dataTestId="media-grid-item"
          ariaLabel={i18n.translate('hotel_images')}
          containerButtonClassName={STYLES.ImageItem__buttonContainer}
          className={STYLES.ImageItem}
          sources={
            isMobile
              ? [
                  {
                    srcSet: buildMobileImageSrcset(src),
                  },
                ]
              : [
                  {
                    media: '(max-width: 1200px)',
                    srcSet: buildTabletImageSrcset(src),
                  },
                  {
                    media: '(min-width: 1201px)',
                    srcSet: buildDesktopImageSrcset(src),
                  },
                ]
          }
          alt=""
          src={src}
          lazyLoad={lazyLoad}
          onClick={() => openGallery(openGalleryProps)}
          mbdProps={mbdProps}
        >
          {showVideoPlayOverlay && <PlayOverlay />}
        </ProgressivePictureButton>
      );
    }}
  </BpkBreakpoint>
);
export default withI18n(ImageItem);
